import { render, staticRenderFns } from "./CityHeader.vue?vue&type=template&id=045ca3bc&scoped=true"
import script from "./CityHeader.vue?vue&type=script&lang=js"
export * from "./CityHeader.vue?vue&type=script&lang=js"
import style0 from "./CityHeader.vue?vue&type=style&index=0&id=045ca3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ca3bc",
  null
  
)

export default component.exports